import React from 'react';

const useAccordion = () => {
  const [isCollapsed, setCollapsed] = React.useState(false);

  const collapse = React.useCallback(() => {
    setCollapsed(true);
  }, [setCollapsed]);

  const expand = React.useCallback(() => {
    setCollapsed(false);
  }, [setCollapsed]);

  return {
    collapse,
    expand,
    isCollapsed,
  };
};

export default useAccordion;
